<template>
  <transition
    name="el-drawer-fade"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <div
      v-show="visible"
      class="el-drawer__wrapper"
      tabindex="-1"
    >
      <div
        class="el-drawer__container"
        :class="visible && 'el-drawer__open'"
        role="document"
        tabindex="-1"
        @mousedown="handleWrapperMousedown"
        @mouseup="handleWrapperMouseup"
      >
        <div
          ref="drawer"
          aria-modal="true"
          aria-labelledby="el-drawer__title"
          :aria-label="title"
          class="el-drawer"
          :class="[direction, customClass]"
          :style="
            isHorizontal ? `width: ${drawerSize}` : `height: ${drawerSize}`
          "
          role="dialog"
          tabindex="-1"
        >
          <header
            v-if="withHeader"
            id="el-drawer__title"
            class="el-drawer__header"
          >
            <slot name="title">
              <span
                role="heading"
                :title="title"
              >{{ title }}</span>
            </slot>
            <button
              v-if="showClose"
              :aria-label="`close ${title || 'drawer'}`"
              class="el-drawer__close-btn"
              type="button"
              @click="closeDrawer"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </header>
          <section
            v-if="rendered"
            class="el-drawer__body"
          >
            <slot></slot>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from 'element-ui/lib/utils/popup';
import emitter from 'element-ui/lib/mixins/emitter';

export default {
  name: 'ElDrawer',
  mixins: [Popup, emitter],
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function
    },
    customClass: {
      type: String,
      default: ''
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'rtl',
      validator (val) {
        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
      }
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: [Number, String],
      default: '30%'
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean
    },
    wrapperClosable: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      closed: false,
      prevActiveElement: null,
      mousedownTargetInDrawer: false
    };
  },
  computed: {
    isHorizontal () {
      return this.direction === 'rtl' || this.direction === 'ltr';
    },
    drawerSize () {
      return typeof this.size === 'number' ? `${this.size}px` : this.size;
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.closed = false;
        this.$emit('open');
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
        this.prevActiveElement = document.activeElement;
      } else {
        if (!this.closed) {
          this.$emit('close');
          if (this.destroyOnClose === true) {
            this.rendered = false;
          }
        }
        this.$nextTick(() => {
          if (this.prevActiveElement) {
            this.prevActiveElement.focus();
          }
        });
      }
    }
  },
  mounted () {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed () {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    afterEnter () {
      this.$emit('opened');
    },
    afterLeave () {
      this.$emit('closed');
    },
    hide (cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.destroyOnClose === true) {
          this.rendered = false;
        }
        this.closed = true;
      }
    },
    // handleWrapperClick () {
    // if (this.wrapperClosable) {
    //   this.closeDrawer();
    // }
    // },
    handleWrapperMousedown (e) {
      this.mousedownTargetInDrawer = this.$refs.drawer.contains(e.target) || this.$refs.drawer === e.target;
    },
    handleWrapperMouseup (e) {
      if (this.wrapperClosable && !this.mousedownTargetInDrawer) {
        this.closeDrawer();
      }
      this.mousedownTargetInDrawer = false;
    },
    closeDrawer () {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    handleClose () {
      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
      // pressing `ESC` will call this method, and also close the drawer.
      // This method also calls `beforeClose` if there was one.
      this.closeDrawer();
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?72f847cf